export interface IMoveCategoriesRequest {
    current_id: string;
    move_to: string[];
}
